import React, { useState, useEffect } from "react";
import { Table, Button, Form, Select, Input } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { listAddons, listVersions } from "@/apis/addons";
import { edit } from "ace-builds";

const { Option } = Select;


export const RequireTable = ({dataSource = [], editable = false, formRef}) => {
  const [addons, setAddons] = useState([]);
  const [versionOptionsMap, setVersionOptionsMap] = useState({})
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  let counter = 0;

  const generateUniqueId = () => {
    return 'id-' + Date.now() + '-' + Math.floor(Math.random() * 1000000);
  }

  useEffect(() => {
    const getAddons = async () => {
      const result = await listAddons();
      if("OK" === result.status) {
        setAddons(result.value);
      }
    }
    getAddons();
  }, [ dataSource.length ]);

  useEffect(() => {
    if(addons.length > 0 && dataSource) {
      if(editable)
        setTableData(dataSource.map((item, index) => {return {_id: generateUniqueId(), id: item.addon, addon: item.addon, version: item.version}}));
      else 
        setTableData(dataSource.map((item) => {return {id: item.addon, addon: addons.find((addon) => addon.id == item.addon)?.name, version: item.version}}));
    }
  }, [addons])

  useEffect(() => {
    if(dataSource.length > 0) {
      dataSource.forEach((item) => {
        addVersionOption(item["addon"]);
      })
    }
  }, [ dataSource.length ]);

  const fetchVersions = async (addonId) => {
    if (!addonId) return;
    try {
      setLoading(true);
      const response = await listVersions(addonId);
      if(response.status == "OK") {
        return response.value.map(item => ({
          label: item.version,
          value: item.version
        }));
      } else 
        return [];
    } catch (error) {
      console.error('Failed to fetch sub-categories:', error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const addRow = () => {
    const newRow = {
      _id: generateUniqueId(),
      id: '',
      addon: '',
      version: ''
    };
    setTableData([...tableData, newRow]);
  };

  const handleDelete = (key) => {
    const updatedData = tableData.filter((item) => item._id !== key);
    setTableData(updatedData);
  };

  const addVersionOption = async (value) => {
    if(!versionOptionsMap[value]) {
      const vers = await fetchVersions(value);
      setVersionOptionsMap((prevMap) => ({
        ...prevMap,
        [value]: vers
      }));
    }
  }

  const handleAddonChange = async (value, record, formRef) => {
    const newData = tableData.map(item => {
      if (item._id === record._id) {
        const dep = formRef.getFieldValue("tableData");
        if(dep[record._id]) {
          dep[record._id].version = "";
          formRef.setFieldValue(dep);
        }
        return { ...item, id: value, addon: value, version: "" };
      }
      return item;
    });
    setTableData(newData);
    addVersionOption(value);
  };

  const handleVersionChange = (value, record) => {
    const newData = tableData.map(item => {
      if (item.key === record.key) {
        return { ...item, version: value };
      }
      return item;
    });
    setTableData(newData);
  };

  const columns = [
    // { 
    //   title: "ID", 
    //   dataIndex: "id", 
    //   key: "id",
    //   render: (value, record) => {
    //     if(editable) {
    //       return (<Form.Item
    //         style={{height: '5px'}}
    //         name={['tableData', record["_id"], 'id']}
    //         rules={[{ required: true, message: 'Please select the addon' }]}
    //         initialValue={value}
    //       >
    //         <Input initialValue={value}/>
    //       </Form.Item>)
    //     } else {
    //       return value;
    //     }
    //   }
    // },
    { title: "Add-on", 
      dataIndex: "addon", 
      key: "addon",
      render: (value, record) => {
        if(editable) {
          return (<Form.Item
            style={{height: '5px'}}
            name={['tableData',record["_id"], 'addon']}
            rules={[{ required: true, message: 'Please select the addon' }]}
            initialValue={value}
          >
            <Select
              onChange={(val) => handleAddonChange(val, record, formRef)}
              placeholder="Please select the addon"
              style={{ width: '100%' }}
            >
              {addons.map((addon) => (
                <Option key={addon.id} value={addon.id}>
                  {addon.name}
                </Option>
              ))}
            </Select>
          </Form.Item>)
        } else {
          return value;
        }
      }
    },
    { title: "Version", 
      dataIndex: "version", 
      key: "version",
      render: (value, record) => {
        if(editable) {
          return (
            <Form.Item
              name={['tableData',record["_id"], 'version']}
              rules={[{ required: true, message: 'Please select the version' }]}
              style={{'height': '5px'}}
              initialValue={value}
            >
              <Select
                onChange={(val) => handleVersionChange(val, record)}
                placeholder="Please select the version"
                style={{ width: '100%' }}
              >
                {versionOptionsMap[record['addon']]?.map((version) => (
                  <Option value={version.value}>
                    {version.label}
                  </Option>
                ))}
              </Select> 
            </Form.Item>
          )
        } else {
          return value;
        }
      }
    }
  ];

  if(editable) {
    columns.push(
      {
        title: '',
        width: 30,
        render: (_, record) => <Button size="small" shape="circle" icon={<MinusOutlined />} onClick={() => handleDelete(record._id)} />,
      }
    )
  }

  return (
    <div style={{ display: "flex", flexDirection: "row", gap: 16 }}>
      <Table
        rowKey="_id"
        dataSource={tableData}
        columns={columns}
        rowSelection={false}
        pagination={false} 
        bordered
        size="small"
        style={{ flex: 1 }}
      />

      {editable && <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Button
          type="primary"
          shape="circle"
          icon={<PlusOutlined />}
          onClick={addRow}
          style={{ marginBottom: 8 }}
        />
      </div>}
    </div>
  );
};

export default RequireTable;